export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SiteFooter.vue?vue&type=template&id=0b0b4c15&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SiteFooter.vue?vue&type=template&id=0b0b4c15&scoped=true
// module id = 187
// module chunks = 0